import Vue from 'vue'
import Vuex from 'vuex'

import categories from "@/modules/category/store/categories"
import products from "@/modules/product/store/products"
import notifications from "@/modules/notifications/store/notifications";
import auth from "@/modules/auth/store/auth";
import menus from "@/modules/menu/store/menus";
import orders from "@/modules/order/store/orders";
import outlets from "@/modules/outlets/store/outlets";
import clients from "@/modules/client/store/clients";
import menuParts from "@/modules/menu/store/menu-parts";
import crudList from "@/core/store/common/crud-list";
import statistics from "@/modules/home/store/statistics";
import users from "@/modules/user/store/users";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    categories: categories,
    products: products,
    notifications: notifications,
    outlets: outlets,
    menus: menus,
    orders: orders,
    clients: clients,
    auth: auth,
    menuParts: menuParts,
    crudList:crudList,
    statistics:statistics,
    users:users
  },
  plugins:[]
})
